// Action key prefix for service case integrations
export const SERVICE_CASE_INTEGRATION_ACTION_PREFIX = 'service-case/integration/';
